import { useRouter } from "next/router";
import { Toaster } from "react-hot-toast";
import { useTheme } from "next-themes";
import React, { useEffect } from "react";
import Manage_modal from "./modal/Manage_Modal";
import DashboardLayout from "../layouts/DashboardLayout";
import Buy_Domains_Modal from "./modal/Buy_Domains_Modal";
import Netzylo_Modal from "./modal/Netzylo_modal";
import CartDrawer from "./cartDrawer";
import { motion } from "framer-motion";

import Meta from "./Meta";
import SimpleLayout from "../layouts/SimpleLayout";
import CommunityLayout from "../layouts/CommunityLayout";
import { FaRegUser, FaAngleDown, FaUser, FaWallet } from "react-icons/fa";
import { FiSearch, FiSun } from "react-icons/fi";

import { IoSunny, IoWalletOutline } from "react-icons/io5";
import Link from "next/link";
import Image from "next/image";
import DarkModeSwitcher from "./mode/DarkMode";
import { MdLogout } from "react-icons/md";
import { useWalletDisconnect } from "../hooks/useWalletDisconnect";
import { Menu } from "@headlessui/react";
import { useActiveAccount } from "thirdweb/react";
import { polygon } from "thirdweb/chains";
import { useWalletBalanceV5 } from "../hooks/useWalletBalanceV5";
import { RiNftLine } from "react-icons/ri";

import { createThirdwebClient } from "thirdweb";
import { useWalletDetailsModal } from "thirdweb/react";
import CartIconButton from "./CartIconButton";
import convertB2ToS3Url from "../utils/convertB2toS3Url";

export default function Layout({ children, headerData }) {
  const route = useRouter();

  const account = useActiveAccount();
  const {
    displayValue: userBalance,
    symbol,
    getFormattedBalance,
    isLoading: userBalanceFetching,
  } = useWalletBalanceV5(polygon);

  // Use the new JSON structure
  const brandConfig = headerData?.brand?.config || {};
  const themeConfig = headerData?.brand?.theme || {};
  const singinConfig = headerData?.brand?.config?.signin || {};

  const { theme } = useTheme();

  // Default theme colors if headerData is not available
  const defaultThemeColors = {
    dark: {
      backgroundColor: "#111827",
      borderColor: "#374151",
      buttonForeColor: "#ffffff",
      buttonBackColor: "#02f6d1",
      themeColor: "#02f6d1",
    },
    light: {
      backgroundColor: "#ffffff",
      borderColor: "#e5e7eb",
      buttonForeColor: "#ffffff",
      buttonBackColor: "#3b82f6",
      themeColor: "#3b82f6",
    },
  };

  // Use headerData if available, otherwise use default colors
  const themeColors = {
    dark: {
      colors: {
        modalBg:
          themeConfig.background || defaultThemeColors.dark.backgroundColor,
        borderColor: themeConfig.icons || defaultThemeColors.dark.borderColor,
        primaryButtonText: "#ffffff",
        primaryButtonBg:
          themeConfig.buttons || defaultThemeColors.dark.buttonBackColor,
        primaryText: themeConfig.text || defaultThemeColors.dark.themeColor,
        secondaryText:
          themeConfig.icons || defaultThemeColors.dark.buttonBackColor,
      },
    },
    light: {
      colors: {
        modalBg:
          themeConfig.background || defaultThemeColors.dark.backgroundColor,
        borderColor: themeConfig.icons || defaultThemeColors.light.borderColor,
        primaryButtonText: "#ffffff",
        primaryButtonBg:
          themeConfig.buttons || defaultThemeColors.light.buttonBackColor,
        primaryText: themeConfig.text || defaultThemeColors.light.themeColor,
        secondaryText:
          themeConfig.icons || defaultThemeColors.light.buttonBackColor,
      },
    },
  };

  const currentTheme = theme === "dark" ? themeColors.dark : themeColors.light;
  const backgroundImage = singinConfig?.backgroundImage || "";
  const toastTheme = {
    dark: {
      border: `2px solid ${themeConfig.text || "#02f6d1"}`,
      background: themeConfig.background || "#111827",
      color: "#ffffff",
    },
    light: {
      border: `2px solid ${themeConfig.text || "#3b82f6"}`,
      background: "#ffffff",
      color: themeConfig.text || "#000000",
    },
  };

  const getLayout = () => {
    if (route.pathname.startsWith("/dashboard/community")) {
      return CommunityLayout;
    } else if (route.pathname.startsWith("/dashboard")) {
      return DashboardLayout;
    } else {
      return SimpleLayout;
    }
  };

  const Layout = getLayout();

  const { handleDisconnect } = useWalletDisconnect();

  const logoutUser = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    try {
      await fetch("/api/auth/logout", { method: "GET" });
      await handleDisconnect();
    } catch (error) {
      console.error("Failed to disconnect wallet:", error);
    }
  };

  const { theme: nextTheme } = useTheme();
  const router = useRouter();
  const client = createThirdwebClient({
    clientId: process.env.NEXT_PUBLIC_THIRDWEB_CLIENT_ID,
  });

  const walletDetailsModal = useWalletDetailsModal();
  const handleWalletDetailsClick = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    try {
      await walletDetailsModal.open({
        chains: [polygon],
        theme: nextTheme,
        client,
        onDisconnect: async () => {
          await fetch("/api/auth/logout", { method: "GET" });
          router.push("/signin");
        },
      });
    } catch (error) {
      console.error("Failed to open wallet details:", error);
    }
  };
  const MenuItems = [
    {
      icon: <IoWalletOutline className="w-4 h-4" />,
      text: "My Wallet",
      href: "/wallet",
      type: "link",
    },
    {
      icon: <IoWalletOutline className="w-4 h-4" />,
      text: "Buy/Sell",
      onClick: handleWalletDetailsClick,
      type: "button",
      class: " flex items-center gap-2 px-3 font-semibold py-4",
    },
    {
      icon: <FaRegUser className="w-4 h-4" />,
      text: "Account Settings",
      href: "/profile",
      type: "link",
    },
    {
      icon: <RiNftLine className="w-4 h-4" />,
      text: "Get Username",
      href: "/discover",
      type: "link",
    },
    {
      icon: <MdLogout className="w-4 h-4" />,
      text: "Sign Out",
      onClick: logoutUser,
      type: "button",
      class:
        " flex items-center gap-2 px-3 font-semibold py-4",
    },
  ];

  // Check if current page is a login page
  const isLoginPage =
    route.pathname.startsWith("/signin") || route.pathname.startsWith("/login");
  const isdicoverpage = route.pathname.startsWith("/discover");
  return (
    <>
      <Meta />
      <div
        style={{
          backgroundColor:
            themeConfig.background || defaultThemeColors.dark.backgroundColor,
          ...(isLoginPage &&
          backgroundImage &&
          backgroundImage !== "undefined" &&
          backgroundImage !== ""
            ? {
                backgroundImage: `url("${encodeURI(convertB2ToS3Url(backgroundImage))}")`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
              }
            : {}),
        }}
        className="min-h-screen"
      >
        <motion.div
          className="z-[99999] w-full flex items-center justify-between py-4  top-0 bg-transparent"
        >
          <div className="w-full max-w-7xl mx-auto flex items-center justify-between">
            <Link className="shrink-0 block" href="/">
              <div className="dark:hidden">
                <Image
                  src={convertB2ToS3Url(brandConfig.logo) || "/netzylo-dark.png"}
                  height={28}
                  width={90}
                  alt="Netzylo"
                  className="h-14 w-auto"
                />
              </div>
              <div className="hidden dark:block">
                <Image
                  src={convertB2ToS3Url(brandConfig.logo) || "/netzylo-dark.png"}
                  height={28}
                  width={90}
                  alt="Netzylo"
                  className="h-14 w-auto"
                />
              </div>
            </Link>
            {/* Cart Icon Button (Global) */}
            <div className="flex items-center gap-4">
            {account &&  <CartIconButton
                className="relative rounded-full p-2 shadow-md hover:scale-105 transition-transform border border-accent"
                style={{
                  borderColor: currentTheme.colors.primaryButtonBg,
                  background: currentTheme.colors.modalBg,
                }}
                iconStyle={{ color: currentTheme.colors.secondaryText, width: 24, height: 24 }}
                badgeStyle={{ background: currentTheme.colors.primaryButtonBg, color: currentTheme.colors.primaryButtonText }}
                theme={{
                  buttons: currentTheme.colors.primaryButtonBg,
                  icons: currentTheme.colors.secondaryText,
                  background: currentTheme.colors.modalBg,
                  text: currentTheme.colors.primaryButtonText,
                }}
              />
              }
              {/* Simplified Wallet Dropdown */}
              {
                account ? (
                  <div
                    className="relative inline-block text-left rounded-lg"
                    style={{
                      border: `2px solid ${themeConfig.icons || "#02f6d1"}`,
                    }}
                  >
                    <Menu>
                      {({ open }) => (
                        <>
                          <Menu.Button
                            className="rounded-lg p-2 flex items-center gap-2 w-[166px] cursor-pointer transition-colors group"
                            style={{
                              backgroundColor: currentTheme.colors.modalBg,
                              borderColor: currentTheme.colors.borderColor,
                              color: currentTheme.colors.primaryText,
                            }}
                          >
                            {headerData?.metadata?.profileImage ? (
                              <img
                                src={convertB2ToS3Url(headerData.metadata.profileImage)}
                                width={20}
                                height={20}
                                alt="Wallet logo"
                                className="rounded-full"
                              />
                            ) : (
                              <FaUser
                                className="w-5 h-5"
                                style={{
                                  color: currentTheme.colors.secondaryText,
                                }}
                              />
                            )}
                            <div>
                              <p
                                className="line-clamp-1 w-24 text-sm font-medium mb-1 group-hover:text-white text-start"
                                style={{ color: currentTheme.colors.primaryText }}
                              >
                                {account.address}
                              </p>
                              <p
                                className="text-xs text-start group-hover:text-white"
                                style={{
                                  color: currentTheme.colors.secondaryText,
                                }}
                              >
                                {getFormattedBalance(3)} MATIC
                              </p>
                            </div>
                            <FaAngleDown
                              className={`ml-2 transition-transform duration-200 ${
                                open ? "rotate-180" : ""
                              }`}
                              style={{ color: currentTheme.colors.primaryText }}
                            />
                          </Menu.Button>

                          <Menu.Items
                            className="absolute right-0 mt-2 w-56 !z-[99999] rounded-xl shadow-md focus:outline-none"
                            style={{
                              backgroundColor: currentTheme.colors.modalBg,

                              border: `2px solid ${currentTheme.colors.borderColor}`,
                            }}
                          >
                            {MenuItems.map((item, index) => (
                              <Menu.Item key={index} as="div">
                                {({ active }) => {
                                  const baseStyle = {
                                    backgroundColor: active
                                      ? currentTheme.colors.primaryButtonBg
                                      : "transparent",
                                    color: active
                                      ? currentTheme.colors.primaryButtonText
                                      : currentTheme.colors.primaryText,
                                  };

                                  if (item.type === "link") {
                                    return (
                                      <Link
                                        href={item.href}
                                        className="flex items-center gap-2 px-3 py-3 w-full rounded-lg"
                                        style={baseStyle}
                                      >
                                        {item.icon}
                                        <span className="text-sm">
                                          {item.text}
                                        </span>
                                      </Link>
                                    );
                                  }
                                  if (item.type === "component") {
                                    return (
                                      <div
                                        className={`text-jacarta-900 hover:text-white dark:text-white dark:hover:bg-white dark:hover:text-gray-300           hover:bg-jacarta-900  flex items-center justify-between  px-3`}
                                      >
                                        <div className="flex items-center gap-2">
                                          {item.icon}
                                          <span className="text-sm ">
                                            {item.text}
                                          </span>
                                        </div>
                                        <div>{item.component}</div>
                                      </div>
                                    );
                                  }

                                  if (item.type === "button") {
                                    return (
                                      <button
                                        style={baseStyle}
                                        className="flex items-center gap-2 px-3 py-3 w-full rounded-lg"
                                      // className={`${baseStyle.backgroundColor} ${item.class}`}
                                      onClick={item.onClick}
                                      >
                                        {item.icon}
                                        <span className="text-sm">
                                          {item.text}
                                        </span>
                                      </button>
                                    );
                                  }
                                }}
                              </Menu.Item>
                            ))}
                          </Menu.Items>
                        </>
                      )}
                    </Menu>
                  </div>
                ) : (
                  <></>
                )
                // <DarkModeSwitcher />
              }
            </div>
          </div>
        </motion.div>
        <div
          className={`w-full ${!isdicoverpage ? "max-w-7xl mx-auto" : ""}  `}
        >
          {/* Header */}

          <Toaster
            toastOptions={{
              duration: 2000,
              style: theme === "dark" ? toastTheme.dark : toastTheme.light,
            }}
            position="top-center"
            reverseOrder={false}
          />
          <Manage_modal />
          <Buy_Domains_Modal />
          <Netzylo_Modal />
          <CartDrawer />
          <Layout style={{ backgroundColor: currentTheme.colors.modalBg }}>
            {children}
          </Layout>

          {/* Powered by Netzylo footer */}
          <div className="w-full py- flex  items-center justify-center  mt-auto  py-6  bottom-0 left-0 right-0">
            <span className="text-sm text-gray-500">Powered by </span>
            <Image
              src="https://www.netzylo.com/netzylo-dark.png"
              alt="Netzylo"
              width={80}
              height={24}
              className=""
            />
          </div>
        </div>
      </div>
    </>
  );
}
